import React, { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function NewProjectRedirect({ backendUrl }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Flaga, by zapobiec podwójnemu uruchomieniu w Strict Mode
  const didRunRef = useRef(false);

  useEffect(() => {
    if (didRunRef.current) {
      // Już wywołane => wyjdź (React 18 dev mode)
      return;
    }
    didRunRef.current = true;

    const docNumber = searchParams.get("ID");
    if (!docNumber) {
      alert("Brak parametru ?ID= w linku.");
      navigate("/");
      return;
    }

    const run = async () => {
      try {
        const url = `${backendUrl}/client/new-project?docNumber=${encodeURIComponent(docNumber)}`;
        console.log("[NewProjectRedirect] => GET =>", url);

        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`Błąd tworzenia projektu (status=${res.status}).`);
        }
        const data = await res.json();
        if (!data.success) {
          throw new Error(data.message || "Nie udało się stworzyć nowego zamówienia.");
        }

        // Mamy publicAccessKey, downloadKey => redirect
        const pubKey = data.publicAccessKey;
        const dKey = data.downloadKey;
        console.log("[NewProjectRedirect] => utworzono =>", pubKey, dKey);

        // Przejście do edytora w trybie public
        navigate(`/client/orders/${pubKey}/pdf-editor/${dKey}`);
      } catch (err) {
        console.error("[NewProjectRedirect] => error:", err);
        alert(`Błąd tworzenia nowego projektu: ${err.message}`);
        navigate("/");
      }
    };

    run();
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <p>Trwa tworzenie nowego zamówienia...</p>
    </div>
  );
}
